<template>
  <div id="contact-form">
    <v-form
      name="second-test"
      ref="form"
      metho="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      v-model="valid"
      netlify
    >
      <v-text-field
        type="hidden"
        name="form-name"
        value="second-request"
        class="hidden"
      ></v-text-field>
      <v-container>
        <v-layout>
          <v-flex xs12 md4>
            <v-text-field
              v-model="first_name"
              name="first_name"
              :rules="nameRules"
              :counter="10"
              label="First name"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              name="last_name"
              v-model="last_name"
              :rules="nameRules"
              :counter="10"
              label="Last name"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field 
              v-model="email"
              name="email"
              :rules="emailRules" 
              label="E-mail" 
              >
            </v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-btn @click="handleSubmit()">submit</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    first_name: "",
    last_name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => v.length <= 10 || "Name must be less than 10 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  methods: {
    encode (data) {
      console.log(data);
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit () {
      const axiosConfig = {
        header: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      // console.log(this.data.first_name).bind(this);
      axios.post(
        "/",
        this.encode({
          "form-name": "second-request",
          "first_name": this.first_name,
          "last_name": this.last_name,
          "email": this.email,
          ...this.form
        }),
        axiosConfig
      );
    }
  }
};
// export default {
//   name: "QAForm",
//   methods: {
//     updatePanelist (ev) {
//       this.currentPanelist = ev.target.value
//     }
//   },
//   data () {
//     return {
//       panelists: ['Evan You', 'Chris Fritz'],
//       currentPanelist: 'Evan You'
//     }
//   }
// }
</script>

<style scoped>
.hidden {
  display: none;
}
</style>